import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';
import { SIZE, VARIANT } from '@motorway/mw-highway-code/enums';

import { LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import step1Avif from '../../../../../../../client/assets_seller/landingpages/prize_draw/step1.avif';
import step1Jpg from '../../../../../../../client/assets_seller/landingpages/prize_draw/step1.jpg';
import step2Avif from '../../../../../../../client/assets_seller/landingpages/prize_draw/step2.avif';
import step2Jpg from '../../../../../../../client/assets_seller/landingpages/prize_draw/step2.jpg';
import step3Avif from '../../../../../../../client/assets_seller/landingpages/prize_draw/step3.avif';
import step3Jpg from '../../../../../../../client/assets_seller/landingpages/prize_draw/step3.jpg';
import { usePageRefEvents } from '../../../../common/Hooks/usePageRefEvents';
import { carPrizeDrawSectionLoadEvent, TERMS_LINK } from '../CarPrizeDraw.helpers';
import texts from '../CarPrizeDraw.texts.json';

import styles from './HowToEnter.module.scss';

const LocalT = new MDText(texts.sections.howToEnter);

export const HowToEnter = () => {
  const steps = [{
    image: { avif: step1Avif, jpg: step1Jpg },
    key: 'step1',
  },
  {
    image: { avif: step2Avif, jpg: step2Jpg },
    key: 'step2',
  },
  {
    image: { avif: step3Avif, jpg: step3Jpg },
    key: 'step3',
  }];

  const link = <Hyperlink href={TERMS_LINK} label="click here" size="large" underline={false} />;
  const date = <span>{LocalT.translate('date')}</span>;

  const onValuationClick = () => window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });

  const onRefTrigger = () => carPrizeDrawSectionLoadEvent(LANDING_PAGE_SECTIONS_NAMES.HOW_TO_ENTER);

  const { setRef } = usePageRefEvents({ onRefTrigger });

  return <div ref={(ref) => setRef(ref)} className={styles.howToEnter} data-testid="howToEnter">
    <div>
      <h2 className={styles.title}>{LocalT.translate('title')}</h2>
    </div>
    <ol className={styles.steps}>
      {steps.map(({ image, key }) => <li key={key} className={styles.step}>
        <h5 className={styles.stepTitle}>{LocalT.translate(`steps.${key}.title`)}</h5>
        <p data-thc-style-override className={styles.stepDescription}>{LocalT.translate(`steps.${key}.description`)}</p>
        <picture>
          <source srcSet={image.avif} type="image/avif" />
          <img alt={String(LocalT.translate(`steps.${key}.title`))} src={image.jpg} />
        </picture>
      </li>)}
    </ol>
    <p data-thc-style-override className={styles.termsLink}>{LocalT.translate('termsConditions', { link })}</p>
    <p data-thc-style-override className={styles.compDeadline}>{LocalT.translate('competitionDeadline', { date })}</p>
    <div>
      <Button
        label={LocalT.translate('valuationCTA')}
        onClick={onValuationClick}
        size={SIZE.LARGE}
        variant={VARIANT.PRIMARY}
      />
    </div>
  </div>;
};
